import React from 'react';
import Card, { CardProps } from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { SxStyle } from '../../../../types';

interface Props extends CardProps {
  title: string;
}

const styles: SxStyle = {
  card: {
    padding: 4,
  },
};

const StoryCard = ({ title, children }: Props) => {
  return (
    <Card variant="outlined" sx={styles.card}>
      <Stack spacing={4}>
        <Typography variant="body1-bold">{title}</Typography>
        {children}
      </Stack>
    </Card>
  );
};

export default StoryCard;
